import TeamsPageOverview from '../TeamsPageOverview/component.vue';
import TeamsPageAssignment from '../TeamsPageAssignment/component.vue';
import setup from './setup.js';

export default {
  name: 'teams-page',
  components: { TeamsPageOverview, TeamsPageAssignment },
  setup,
};
